import React, { useContext, useEffect } from "react";
import SEO from "../../utils/SEO";
import styles from "./GiftCards.module.scss";

import { LanguageContext } from "../../context/LanguageContext";

const GIFT_UP_SCRIPT_SRC = "https://cdn.yourgift.cards/dist/gift-up.js";
const GIFT_UP_SITE_ID = "df92df95-a81e-48a9-9869-077767907606";

function GiftCards() {
  const { language } = useContext(LanguageContext);
  const no = language === "no";

  useEffect(() => {
    window.giftup =
      window.giftup ||
      function () {
        (window.giftup.q = window.giftup.q || []).push(arguments);
      };

    // Remove any previous script so Gift Up re-scans the target on SPA revisits
    const existingScript = document.querySelector(
      `script[src="${GIFT_UP_SCRIPT_SRC}"]`
    );
    if (existingScript) {
      existingScript.remove();
    }

    const script = document.createElement("script");
    script.src = GIFT_UP_SCRIPT_SRC;
    script.async = true;
    document.body.appendChild(script);

    return () => {
      script.remove();
    };
  }, []);

  return (
    <>
      <SEO
        title={no ? "Gavekort" : "Gift Cards"}
        description={
          no
            ? "Kjøp digitale gavekort hos Instant Iris – den perfekte gaven til noen du er glad i."
            : "Buy digital gift cards from Instant Iris – the perfect gift for someone you care about."
        }
      />
      <main>
        <section className={styles.giftcards_section}>
          <div className="container">
            <div className="wrap">
              <div
                className="gift-up-target"
                data-site-id={GIFT_UP_SITE_ID}
                data-platform="Other"
              />
            </div>
          </div>
        </section>
      </main>
    </>
  );
}

export default GiftCards;
